module.exports = __webpack_public_path__ + "media/inside_coal_mine.ef4a3be7.mp4";